import React from 'react';
import { Label } from '../Label';
import { colorPalette } from '../../../colorPalette';
export const NouveauPinkLabel = () => (React.createElement(Label, { backgroundColor: "white", letterSpacing: "normal", padding: "2px 6px", fontSize: "8px", textColor: "red400", border: `1px solid ${colorPalette.red400}`, borderRadius: "2px", lineHeight: "10px" }, "Nouveau"));
